import axios from 'axios';
import { IFreshServiceTicketUpsert } from '../../../@types/model/freshService/freshServiceTicketModels';

export default class FreshServiceHttpService {
    public static upsert = async (upsert : IFreshServiceTicketUpsert) : Promise<void> => {
        const result = await axios.post(`${API_URL}/v1/FreshService/CreateTicket`, upsert);

        return result.data;
    }
}
